import { IContactPermission, IPermission, IPermissionGroup } from "@interface/customerDetails/ICustomerDetails";
import { ACTIVE_CUSTOMER, ALLOW_3RD_PARTIES, NO_LONGER_CUSTOMER, PERMISSION_GROUPS } from "@constants";
import {
    EPermissions,
    IMarketingPreferencesForm,
    IPermissionNameValue,
} from "@features/customerDetails/ICustomerDetailsForm";

const mapContactPermissionItem = (permissionNameValue: IPermissionNameValue): IPermission[] => {
    return Object.entries(permissionNameValue).map(([permissionName, permissionValue]) => ({
        enabled: permissionValue,
        name: permissionName as keyof typeof EPermissions,
        permission: permissionName,
    }));
};

export const mapContactPermission = (permissionsForm: IMarketingPreferencesForm): IContactPermission => {
    const permissionsAllowThirdParty: IPermission[] = mapContactPermissionItem(permissionsForm.allowThirdParty);
    const permissionsNoLongerCustomer: IPermission[] = mapContactPermissionItem(permissionsForm.noLongerCustomer);
    const permissionsActiveCustomer: IPermission[] = mapContactPermissionItem(permissionsForm.activeCustomer);

    const permissionGroups: IPermissionGroup[] = PERMISSION_GROUPS.map((value) => {
        let permissions: IPermission[];
        switch (value) {
            case ACTIVE_CUSTOMER:
                permissions = permissionsActiveCustomer;
                break;
            case NO_LONGER_CUSTOMER:
                permissions = permissionsNoLongerCustomer;
                break;
            case ALLOW_3RD_PARTIES:
                permissions = permissionsAllowThirdParty;
                break;
            default:
                permissions = [];
                break;
        }

        return {
            name: value,
            permissionGroup: value,
            permissions,
        };
    });

    return {
        permissionGroups,
    };
};
